import React, { useEffect, useState } from "react";
import { useLanguage, T, pickBilingual } from "@/lib/i18n";

function initials(name = "") {
  return name.split(/\s+/).map((s) => s[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}

export default function Leadership() {
  const { lang } = useLanguage();
  const [members, setMembers] = useState([]);


  return (
    <section id="leadership" data-testid="leadership-section" className="bg-white border-t border-sjm-line">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-28 lg:py-32">
        <div className="mb-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-sjm-red">{T.leaders.eyebrow[lang]}</div>
          <h2 className={`mt-3 font-display font-extrabold tracking-tighter text-3xl sm:text-4xl lg:text-5xl text-sjm-ink ${lang === "bn" ? "font-bn" : ""}`}>
            {T.leaders.title[lang]}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border border-sjm-line">
          {(Array.isArray(members) ? members : []).map((m, i) => {
            const name = pickBilingual(m, "name", lang);
            return (
              <div
                key={m.id}
                data-testid={`member-card-${i}`}
                className="p-6 border-b sm:border-b-0 sm:border-r last:border-r-0 border-sjm-line group hover:bg-sjm-mist transition-colors"
              >
                <div className="aspect-square bg-sjm-mist border border-sjm-line flex items-center justify-center overflow-hidden mb-5">
                  {m.photo_url ? (
                    <img src={m.photo_url} alt={name} className="w-full h-full object-cover" />
                  ) : (
                    <span className="font-display font-extrabold text-5xl text-sjm-red">{initials(m.name_en || name)}</span>
                  )}
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-sjm-red font-bold mb-1">
                  {pickBilingual(m, "role", lang)}
                </div>
                <div className={`font-display font-bold text-xl text-sjm-ink ${lang === "bn" ? "font-bn" : ""}`}>{name}</div>
                <p className={`mt-2 text-sm text-sjm-muted leading-relaxed line-clamp-3 ${lang === "bn" ? "font-bn" : ""}`}>
                  {pickBilingual(m, "bio", lang)}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 border-t border-sjm-line pt-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {[
              {
                href: "https://www.youtube.com/watch?v=hPrc-HK5v5o",
                src: "https://i.ytimg.com/vi/hPrc-HK5v5o/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAX3uukw5U9ew4r1aJlIGrkm--xcw",
                title: "DA Protest | Sangrami Joutha Mancha | ৯০ শতাংশের বেশি কর্মচারী ধর্মঘটের সমর্থনে: ভাস্কর ঘোষ - YouTube",
              },
              {
                href: "https://www.youtube.com/watch?v=J9N0nNPGtoI",
                src: "https://i.ytimg.com/vi/J9N0nNPGtoI/sddefault.jpg",
                title: "সংগ্রামী যৌথ মঞ্চের সাংবাদিক বৈঠক  Sangrami Joutha Mancha - YouTube",
              },
              {
                href: "https://www.youtube.com/watch?v=AeXbh11pVDg",
                src: "https://i.ytimg.com/vi/AeXbh11pVDg/maxresdefault.jpg",
                title: "Bhaskar Ghosh | Sangrami Joutha Mancha | ৩ বছরে সংগ্রামী যৌথ মঞ্চ | West Bengal News - YouTube",
              },
              {
                href: "https://www.youtube.com/watch?v=JJ7UdanlxFk",
                src: "https://i.ytimg.com/vi/JJ7UdanlxFk/hqdefault.jpg",
                title: "Sangrami Joutha Mancha: বাঁকুড়ায় নেতাকে হকি স্টিক দিয়ে মার! অভিযোগ TMC-র বিরুদ্ধে",
              },
              {
                href: "https://www.youtube.com/watch?v=7I15LKBScSY",
                src: "https://i.ytimg.com/vi/7I15LKBScSY/hqdefault.jpg",
                title: "Sangrami Joutha Mancha Agitation | বকেয়া DA-এর দাবিতে প্রতিবাদ সংগ্রামী যৌথ মঞ্চের | Ei Samay",
              },
              {
                href: "https://www.youtube.com/watch?v=GBMfnoyR9Gk",
                src: "https://i.ytimg.com/vi/GBMfnoyR9Gk/hqdefault.jpg",
                title: "DA Protest | কর্মীদের অফিসে ঢুকতে বাধা! ডিএর দাবিতে ধর্মঘটের ডাক সংগ্রামী যৌথ মঞ্চের | Bangla News",
              },
            ].map((video) => (
              <a
                key={video.href}
                href={video.href}
                target="_blank"
                rel="noreferrer noopener"
                className="overflow-hidden rounded-xl border border-sjm-line bg-sjm-mist group"
              >
                <img
                  src={video.src}
                  alt={video.title}
                  className="w-full h-72 object-cover transition duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="p-4 text-sm font-bold text-sjm-ink">{video.title}</div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
